import {
  CLEAR_FULFILLMENT_INFO,
  CREDIT_FULFILLMENT_FAILURE,
  CREDIT_FULFILLMENT_REQUEST,
  CREDIT_FULFILLMENT_SUCCESS,
  CREDIT_ON_DEMAND,
  CREDIT_PULLINFO_FAILURE,
  CREDIT_PULLINFO_REQUEST,
  CREDIT_PULLINFO_SUCCESS,
  CREDIT_REPORT,
  CREDIT_REPORT_ABSTRACT,
  CREDIT_REPORT_ABSTRACT_STATUS,
  CREDIT_REPORT_STATUS,
  CREDIT_SCORE,
  CREDIT_SCORE_STATUS,
  DOWNLOAD_REPORT_STATUS,
  INIT_CREDIT_SDK,
  INIT_CREDIT_SDK_FAILURE,
  INIT_CREDIT_SDK_SUCCESS,
  SET_PROVIDER_BUREAU_DATA,
} from '../actions/credit';

const initialState = {
  credit_score: {},
  credit_score_status: '',
  status_text: '',
  credit_report: {},
  credit_report_status: '',
  credit_report_abstract_status: '',
  download_report_status: '',
  primaryBureau: '',
  creditRangeMax: '850',
  creditOnDemand: false,
  creditPullInfo: {},
  creditPullInfoStatus: '',
  creditFulfillment: {},
  creditReportTypeRequest: '',
  creditFulfillmentStatus: '',
  init_credit_sdk_status: '',
};

export default function credit(state = initialState, action = {}) {
  // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
  switch (action.type) {
    //Equifax
    case CREDIT_SCORE:
      // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
      return Object.assign({}, state, {credit_score: action.credit_score, credit_score_status: 'success'});
    case CREDIT_SCORE_STATUS:
      return Object.assign({}, state, {
        // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
        credit_score_status: action.credit_score_status,
        // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
        status_text: action.status_text,
      });
    case CREDIT_REPORT:
      return Object.assign({}, state, {
        // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
        credit_report: action.credit_report,
        credit_report_status: 'success',
      });
    case CREDIT_REPORT_STATUS:
      // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
      return Object.assign({}, state, {credit_report_status: action.credit_report_status});
    case CREDIT_REPORT_ABSTRACT:
      // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
      return Object.assign({}, state, {credit_report_abstract: action.credit_report_abstract});
    case CREDIT_REPORT_ABSTRACT_STATUS:
      // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
      return Object.assign({}, state, {credit_report_abstract_status: action.credit_report_abstract_status});
    case CREDIT_ON_DEMAND:
      return Object.assign({}, state, {creditOnDemand: true});
    case CREDIT_FULFILLMENT_REQUEST:
      return Object.assign(
        {},
        state,
        {creditFulfillmentStatus: 'loading'},
        // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
        {creditReportTypeRequest: action.reportType}
      );
    case CREDIT_FULFILLMENT_SUCCESS:
      return Object.assign(
        {},
        state,
        // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
        {creditFulfillment: action.fulfillmentInfo},
        {creditFulfillmentStatus: 'success'}
      );
    case CREDIT_FULFILLMENT_FAILURE:
      // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
      return Object.assign({}, state, {creditFulfillment: action.error}, {creditFulfillmentStatus: 'error'});
    case CREDIT_PULLINFO_REQUEST:
      return Object.assign({}, state, {creditPullInfoStatus: 'loading'});
    case CREDIT_PULLINFO_SUCCESS:
      // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
      return Object.assign({}, state, {creditPullInfo: action.pullInfo}, {creditPullInfoStatus: 'success'});
    case CREDIT_PULLINFO_FAILURE:
      return Object.assign({}, state, {creditPullInfoStatus: 'error'});
    case DOWNLOAD_REPORT_STATUS:
      // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
      return Object.assign({}, state, {download_report_status: action.download_report_status});
    case SET_PROVIDER_BUREAU_DATA:
      return Object.assign({}, state, {
        // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
        primaryBureau: action.bureau,
        // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
        creditRangeMax: action.creditMax,
      });
    case CLEAR_FULFILLMENT_INFO:
      return Object.assign({}, state, {creditReportTypeRequest: '', creditFulfillmentStatus: ''});
    case INIT_CREDIT_SDK:
      return Object.assign({}, state, {init_credit_sdk_status: 'loading'});
    case INIT_CREDIT_SDK_SUCCESS:
      return Object.assign({}, state, {init_credit_sdk_status: 'success'});
    case INIT_CREDIT_SDK_FAILURE:
      return Object.assign({}, state, {init_credit_sdk_status: 'error'});
    default:
      return state;
  }
}
